import { useTranslation } from 'react-i18next'

import { Alert } from '@vtex/shoreline'

import ViewBannerCampaign from './Banner'
import ViewBannerVideoCampaign from './BannerVideo'
import ViewDigitalSignageCampaign from './DigitalSignage'
import ViewProductCampaign from './Product'
import ViewSponsoredBrandCampaign from './SponsoredBrand'

type ViewPages = Partial<Record<CampaignAdType, React.FC<ViewCampaignProps>>>

const DetailsViewCampaign: React.FC<ViewCampaignProps> = props => {
  const { t } = useTranslation('rm')
  const adType = props.data.adType

  const Pages: ViewPages = {
    banner: ViewBannerCampaign,
    product: ViewProductCampaign,
    sponsored_brand: ViewSponsoredBrandCampaign,
    digital_signage: ViewDigitalSignageCampaign,
    banner_video: ViewBannerVideoCampaign,
    // WIP
    sponsored_brand_video: ViewSponsoredBrandCampaign,
    banner_off_site: ViewBannerCampaign
  }

  const SelectedPage = Pages?.[adType]

  return SelectedPage ? (
    <SelectedPage {...props} />
  ) : (
    <>
      <Alert variant="warning" className="mb-3">
        {t('rm:campaign.error.unknownAdType')}
      </Alert>

      <Pages.product {...props} />
    </>
  )
}

export default DetailsViewCampaign
